import { getPlayerCommandList } from "./playerCommandsMapping";

export const speechCommandsEN = {
    player: getPlayerCommandList('en')
}